import { useState } from 'react'
import { downloadXLSX } from '@/lib/download-file'
import { captureException } from '@/lib/errors'
import { generateJobsXLSX, type JobsExportRow } from '@/lib/export-jobs-xlsx'

interface UseExportJobsXLSXOptions {
    rows: JobsExportRow[]
    filenamePrefix?: string
}

export function useExportJobsXLSX({ rows, filenamePrefix = 'jobs' }: UseExportJobsXLSXOptions) {
    const [isExporting, setIsExporting] = useState(false)

    const exportToXLSX = async () => {
        if (rows.length === 0) return
        setIsExporting(true)
        try {
            const data = generateJobsXLSX(rows)
            const datestamp = new Date().toISOString().slice(0, 10)
            const filename = `${filenamePrefix}-${datestamp}.xlsx`
            await downloadXLSX(data, filename)
        } catch (error) {
            captureException('Export jobs XLSX failed', error)
        } finally {
            setIsExporting(false)
        }
    }

    return { exportToXLSX, isExporting }
}
